<template>
  <sliderBarDialogShell
    ref="sliderbar"
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    :click-not-close="true"
    class="user-do-dialog"
  >
    <div class="form-content">
      <user-form
        :form-data="formData"
        ref="outform"
        @submit="submit"
      ></user-form>
    </div>
  </sliderBarDialogShell>
</template>

<script>
import userForm from "@/components/sys/userList/userForm";
import {queryUserDetail, updateUser} from "@/api/sys/userList";

export default {
  name: "editUserDialog",
  components: {
    userForm,
  },
  props: {
    userId:{
      type: Number,
    },
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: '编辑',
      formData: {
        userId: '',
      }
    }
  },
  watch:{
    dialogShow(newValue){
      if(newValue && this.userId){
        this.getUserDetail(this.userId);
      }
    },
  },
  methods: {
    getUserDetail(userId){
      queryUserDetail({userId: userId}).then((res) => {
        this.formData = res.user;
      })
    },
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      // todo
      this.$refs.outform.selfValidate();
    },
    submit(form) {
      let treeIds= [];
      let formRef = this.$refs.outform;
      if(formRef.$refs.menuListTree.getCheckedKeys()){
        formRef.$refs.menuListTree.getCheckedNodes().forEach(item => {
          if(item.nodeValue){
            treeIds.push(item.id)
          }
        });
      }

      let params = {
        userId: form.userId,
        'username': form.userName,
        'password': form.password,
        'salt': form.salt,
        'email': form.email,
        'mobile': form.mobile,
        'status': form.status,
        'roleIdList': form.roleId,
        'treeIds':treeIds
      }
      updateUser(params).then((data) => {
        if(data&&data.code&&data.code == 200){
          this.$message({
            message: '修改成功',
            type: 'success',
          });
          this.$emit('edit-success');
        }else{
          this.$message.error(data.msg);
        }
      }).catch((err) => {
        // this.$message.error(err.msg);
      })
    }
  },
}
</script>
<style>
@media screen and (min-width: 768px) {
  .user-do-dialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
